
interface StageParameters {
    [stage: string]: {
        userPoolId: string,
        region: string,
        cognitoClientId: string,
        cognitoDomainName: string,
        cookieDomainName: string,
        secureCookie: boolean,
        gwUrl: string,
    }
}

const stageParameters: StageParameters = {
    dev: {
        userPoolId: "us-east-1_m6U0qUJSM",
        region: "us-east-1",
        cognitoClientId: "3ovlv3baggqk12tpamvsrreb0v",
        cognitoDomainName: "",
        cookieDomainName: ".ridewithvia.com",
        gwUrl: "int.us1.dev.ridewithvia.com/voc",
        secureCookie: false
    },
    staging: {
        userPoolId: "us-east-1_m6U0qUJSM",
        region: "us-east-1",
        cognitoClientId: "3ovlv3baggqk12tpamvsrreb0v",
        cognitoDomainName: "",
        cookieDomainName: ".ridewithvia.com",
        gwUrl: "int.us1.dev.ridewithvia.com/voc",
        secureCookie: false
    },
    prod: {
        userPoolId: "us-east-1_2BkU6BSDt",
        region: "us-east-1",
        cognitoClientId: "61q3ecf2p077rjvlun38g9eej0",
        cognitoDomainName: "admin-auth.ridewithvia.com",
        gwUrl: "us1.ridewithvia.com/voc",
        cookieDomainName: ".ridewithvia.com",
        secureCookie: false
    },
    local: {
        userPoolId: "us-east-1_m6U0qUJSM",
        region: "us-east-1",
        cognitoClientId: "3ovlv3baggqk12tpamvsrreb0v",
        cognitoDomainName: "",
        cookieDomainName: "localhost",
        gwUrl: "int.us1.dev.ridewithvia.com/voc",
        secureCookie: false
    },
    localprod: {
        userPoolId: "us-east-1_2BkU6BSDt",
        region: "us-east-1",
        cognitoClientId: "61q3ecf2p077rjvlun38g9eej0",
        cognitoDomainName: "admin-auth.ridewithvia.com",
        cookieDomainName: "localhost",
        gwUrl: "us1.ridewithvia.com/voc",
        secureCookie: false
    },
};

export default stageParameters;
